import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const ReferralForm = ({ propertyId, serviceType, onSuccess }) => {
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) { toast.error('Please enter your name'); return; }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/referrals`, {
        property_id: propertyId,
        service_type: serviceType,
        ...formData
      });
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to submit request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 mt-4">
      <div>
        <Label className="text-[#1A1A1A]/70 font-semibold">Your Name *</Label>
        <Input value={formData.name} onChange={(e) => setFormData(p => ({ ...p, name: e.target.value }))} required className="bg-[#F8FAFC] border-slate-200 text-[#1A1A1A] h-12" data-testid="referral-name-input" />
      </div>
      <div>
        <Label className="text-[#1A1A1A]/70 font-semibold">Phone</Label>
        <Input value={formData.phone} onChange={(e) => setFormData(p => ({ ...p, phone: e.target.value }))} className="bg-[#F8FAFC] border-slate-200 text-[#1A1A1A] h-12" data-testid="referral-phone-input" />
      </div>
      <div>
        <Label className="text-[#1A1A1A]/70 font-semibold">Email</Label>
        <Input type="email" value={formData.email} onChange={(e) => setFormData(p => ({ ...p, email: e.target.value }))} className="bg-[#F8FAFC] border-slate-200 text-[#1A1A1A] h-12" data-testid="referral-email-input" />
      </div>
      <div>
        <Label className="text-[#1A1A1A]/70 font-semibold">Additional Details</Label>
        <Textarea value={formData.message} onChange={(e) => setFormData(p => ({ ...p, message: e.target.value }))} placeholder="Tell us what you need..." className="bg-[#F8FAFC] border-slate-200 text-[#1A1A1A]" data-testid="referral-message-input" />
      </div>
      <p className="text-xs text-slate-400">We'll match you with a vetted {serviceType} and get back to you.</p>
      <Button type="submit" disabled={loading} className="w-full bg-[#E07A3A] text-white hover:bg-[#C4652E] h-12 font-semibold" data-testid="referral-submit-btn">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Submit Request'}
      </Button>
    </form>
  );
};

export default ReferralForm;
